<template>
	<el-select @change="onSelectManagerChanged" v-model="selectedManagerId" placeholder="Менеджер">
		<template #label="scope">
			<el-text type="info" v-if="scope.value == 0">
				не назначен
			</el-text>
			<el-text v-else>
				{{ formatSelectedManagerLabel() }}
			</el-text>						
		</template>
		<el-option
			v-for="m in mngrs"
			:key="m.id"
			:value="m.id">
			<el-text type="info" v-if="!m.id">
				не назначен
			</el-text>
			<el-text v-else>
				{{ m.lastname }} {{ m.firstname ? ` ${m.firstname.substring(0,1)}.` : '' }}
			</el-text>
		</el-option>
	</el-select>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import EmployeeModel from '@/models/EmployeeModel';
import EmployeesApiHelper from '@/helpers/api/EmployeesApiHelper';
import store from '@/store';
import { watch, WatchStopHandle } from 'vue';

@Options({	
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		managers: {
			type: Array,
			default: null
		},
		allowEmptyManager: {
			type: Boolean,
			default: false
		},
		loadManagers: {
			type: Boolean,
			default: false
		},
		modelValue: {
			type: Number,
			default: 0
		}
	},
	emits: ['update:modelValue'],
})
export default class SelectManagerComponent extends Vue {
	/** props */
	disabled!: boolean;
	managers!: Array<EmployeeModel>;
	loadManagers!: boolean;
	allowEmptyManager!: boolean;
	modelValue!: number;

	/** view-models */
	selectedManagerId: number | null = null;
	mngrs: Array<EmployeeModel> = [];

	modelWatchHandler: WatchStopHandle | null = null;

	mounted() {
		this.selectedManagerId = this.modelValue;

		this.modelWatchHandler = watch(
			() => this.modelValue,
			(managerId: number) => this.selectedManagerId = managerId);
		
		if (this.loadManagers) {
			this.fetchManagersAsync();
		} else {
			if (this.managers) {
				this.mngrs = this.managers.map(_ => new EmployeeModel(_));
			}
		}
	}

	unmounted(): void {
		if (this.modelWatchHandler) {
			this.modelWatchHandler();
		}
	}

	async fetchManagersAsync() {
		if (this.allowEmptyManager) {
			this.mngrs = [
				new EmployeeModel({id: 0})
			];
		}

		const existingManagers = await new EmployeesApiHelper().getManagersAsync(store.getters.jwt);
		existingManagers.forEach(m => this.mngrs.push(m));
	}

	onSelectManagerChanged() {
		this.$emit('update:modelValue', this.selectedManagerId);
	}

	formatSelectedManagerLabel() {
		const selectedManager = this.mngrs.find(_ => _.id == this.selectedManagerId)!;
		if (selectedManager) {
			return `${selectedManager.lastname} ${selectedManager.firstname ? `${selectedManager.firstname.substring(0,1)}.` : '' }`;
		}
	}
}
</script>